$(document).ready(function(){
  var array = [];
  var stickerArr = [];
  function check_transform(){
    $('.count_ul li').each(function(index){
      index=index+1;
      if(index%2 == 0){
        $(this).removeClass('none_transform');
        $(this).addClass('transform_data');
      }else{
        $(this).removeClass('transform_data');
        $(this).addClass('none_transform');
      }
    });
  }
  function cubing_function(a, productid, productimageOne, productimageTwo, productTitle){
    var cube ='<li class="counting_image_'+a+'"><img src="'+ productimageTwo + '" /></li>';
    var cube_data = '<li class="append_cube_'+a+'" pro_id="'+productid+'"><div class="data_append"><span class="count_image"><img src="'+productimageOne+'" /></span><span class="title">'+productTitle+'</span><span class="count_remove" data-id="'+a+'" pro_id="'+productid+'">X</span></div></li>';
    if(productid.indexOf('sticker') > -1){
    }
    else{
    $(".productcube ul.count_ul").append(cube);
    }
    $('.product_cart_area ul.append_club_data').append(cube_data);
   check_transform();
    setTimeout(function(){
      $('a[id="'+productid+'"]').text('Add another');
    }, 1000);
  }
   function cubing_functionstick(a, productid, productimageOne, productimageTwo, productTitle){
    var cube ='<li class="counting_image_'+a+'"><img src="'+ productimageTwo + '" /></li>';
    var cube_data = '<li class="append_cube_'+a+'" pro_id="'+productid+'"><div class="data_append"><span class="count_image"><img src="'+productimageOne+'" /></span><span class="title">'+productTitle+'</span><span class="count_remove" data-id="'+a+'" pro_id="'+productid+'">X</span></div></li>';
    if(productid.indexOf('sticker') > -1){
    }
    else{
//     $(".productcube ul.count_ul").append(cube);
    }
    $('.product_cart_area ul.append_club_data').append(cube_data);
   check_transform();
    setTimeout(function(){
      $('a[id="'+productid+'"]').text('Add another');
    }, 1000);
  }
  
  function removeItemOnce(arr, value) {
  var index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
}


  $("#filter").change(function(){
    $(this).find("option:selected").each(function(){
      var optionValue = $(this).attr("value");
      if(optionValue == 'all'){
        $(".box").show();
      }
      else if(optionValue){
        $(".box").not("." + optionValue).hide();
        $("." + optionValue).show();
      } else{
        $(".box").hide();
      }
    });
  }).change();

  /*****************mini  cart ****************/
  var a = 0;
  $('body').on('click', '.productdata', function(e){
    e.preventDefault();
    a++;
    var check_text = $(this).text();
    var productid = $(this).attr("id");
    var proTitle = $(this).attr("data-handle");
    var productimageOne = $(this).attr("img-one");
    var productimageTwo = $(this).attr("img-two");
    var productTitle = $(this).attr("title");
    var li_length = $('.count_ul li').length;
    
    var parentCheck = $(this).parents('.box').attr('id');

    if(array.length < 5){
      $('.btn_lable_add').attr('disabled', 'disabled');
    }else{
      $('.btn_lable_add').removeAttr('disabled');
    }
    if(array.length >= 6){
      if(parentCheck == 'sticker'){
        if(stickerArr.length >= 1){
          $('.alertSticker').removeClass('hide');
        }else{
          if(check_text == 'Add to mix'){
            $(this).text('Add another');
          }else{
            $(this).text('Adding...');
          }
          stickerArr.push(proTitle);
           
          cubing_functionstick(a, proTitle, productimageOne, productimageTwo, productTitle);
       	$('.miniMineCart').append('<span id="'+proTitle+'" proCount="1">1 X '+proTitle+'</span>');
          $('#sticker .productdata').attr("disabled", "disabled");
        }
      }else{
        $('.btn_lable_add').removeAttr('disabled');
        $('.alert_data').removeClass('hide');
      }
    }else{
      if(check_text == 'Add to mix'){
        $(this).text('Add another');
      }else{
        $(this).text('Adding...');
      }
      if(parentCheck == 'sticker'){
        if(stickerArr.length >= 1){
          $('.alertSticker').removeClass('hide');
        }else{
          stickerArr.push(proTitle);
          cubing_functionstick(a, proTitle, productimageOne, productimageTwo, productTitle);
          $('#sticker .productdata').attr("disabled", "disabled");
        }
      }else{
        array.push(proTitle);
        cubing_function(a, proTitle, productimageOne, productimageTwo, productTitle);
      }
            console.log(array)
      console.log(stickerArr)

      var countArray = 0;
      $.each(array, function(index, value)
      {
        
        if(proTitle == value){
         countArray++; 
        }
      });
      $('#'+proTitle).remove();
	   if(parentCheck == 'sticker')
      {
       $('.miniMineCart').append('<span id="'+proTitle+'" proCount="1">1 X '+proTitle+'</span>');
          
      }
      else
      {
        $('.miniMineCart').append('<span id="'+proTitle+'" proCount="'+countArray+'">'+countArray+' X '+proTitle+'</span>');
     }
    
    }
  });

  $(function() {
    $('.customizeform').click(function (e) {
      e.preventDefault();
      $('body').addClass('popup_opens');
      $("#MyPopup").show();

    });
  });
  
  $('body').on('click', '.popuop_hide', function(){
    $("#MyPopup").hide();
    $('body').removeClass('popup_opens');
  });
  $('body').on('click', '.alert_pop_hide', function(){
    $(".alert_data").addClass('hide');
  });
  
  $('body').on('click', '.list_banner', function(){
    var image_index = $(this).attr('loop-index');
    $('.owl-item .item').removeClass('active_mobile');
    $(this).parent().addClass('active_mobile');
    $('.'+image_index).trigger('click');
    if(image_index == 'image_1'){
     $('.properties_label').addClass('hide'); 
    }else{
      $('.properties_label').removeClass('hide'); 
    }
    var image_src = $(this).attr('data-src');
    var image_id = $(this).attr('data-id');
    $('.preview_item').html('<img src="'+image_src+'" />');
  });
  
  $('#enter-line1-text').keyup(function(){
    var text_val1 = $(this).val();
    $('.line1_text').html(text_val1);
  });
  $('#enter-line2-text').keyup(function(){
    var text_val2 = $(this).val();
    $('.line2_text').html(text_val2);
  });
  
  $('#font_family').change(function(){
    var font_family = $(this).val();
    $('.line1_text, .line2_text').css('font-family', font_family);
  });
  
  $('#font_size').change(function(){
    var font_size = $(this).val();
    $('.line1_text, .line2_text').css('font-size', font_size+'px');
  });
  
  $('#font_color').change(function(){
    var font_color = $(this).val();
    $('.line1_text, .line2_text').css('color', font_color);
  });
  
  
  $('.anchor_pop').click(function(){
    $('#MyPopup').css('display', 'none');
    $('.completed_popup').removeClass('hide');
  });
  
  $('.complete_pop_hide').click(function(){
    $('.completed_popup').addClass('hide');
    $('body').removeClass('popup_opens');
  });
  
  $('body').on('click', '.count_remove', function(){
    var id_link = $(this).attr('data-id');
    var pro_id = $(this).attr('pro_id');
    var count = $('#'+pro_id).attr('proCount');
    var newVal = parseInt(count) - 1;
    $('#'+pro_id).remove();
    if(newVal == 0){
      
    }else{
    $('.miniMineCart').append('<span id="'+pro_id+'" proCount="'+newVal+'">'+newVal+' X '+pro_id+'</span>');
    
    }
    
      removeItemOnce(array, pro_id);
      removeItemOnce(stickerArr, pro_id);
    
//     if(pro_id.indexOf('sticker') > -1){
//       removeItemOnce(stickerArr, pro_id);
//     }else{
//       removeItemOnce(array, pro_id);
//     }
    
    console.log(array);
    $('.btn_lable_add').attr('disabled', 'disabled');
    $('.append_cube_'+id_link).remove();
    $('.counting_image_'+id_link).remove();
    check_transform();
  });
  
  $('body').on('click', '.btn_lable_add', function(e){
    e.preventDefault();
    $('.btn_lable_add span.text').html('Adding....');
    var mainId = $(this).attr('mainid');
    var properties_mine = '';
    var cardMsg = $('#card-message').val();
    console.log(cardMsg);
    if(cardMsg == '' || cardMsg == undefined){
      //nothing to be happen
    }else{
      properties_mine += "properties[Card Message]="+cardMsg;
    }
    $('.miniMineCart span').each(function(index){
      var title = $(this).text();
      if(index == 0){
        properties_mine += "&properties['Flavor"+index+"']="+title;
      }else{
        properties_mine += "&properties['Flavor"+index+"']="+title;
      }
    });
    console.log(properties_mine);
    setTimeout(function(){
      var data_mine = 'quantity=1&id='+mainId+'&'+properties_mine;
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data_mine,
        success: function(res){
          window.location.replace('/cart');
        }
      });
    }, 1000);
  });
  
  $('.alertSticker .alert_pop_hide').click(function(){
    $('.alertSticker').addClass('hide');
  });
});